// =============================================================================
//          (c) Copyright 2021 by Brinks Home Security | Dallas, TX, USA
// =============================================================================
// Version   : 0.1.1
// Created at: 08.26.16
// Project   : Brinks Home Security Shared Assets
// -----------------------------------------------------------------------------
// JS extensions and helpers for Bootstrap's Collapse component
// -----------------------------------------------------------------------------

const Collapse = (($) => {
  const SELECTOR = '.navbar-collapse'

  const Event = {
    SHOWN: 'shown.bs.collapse',
    HIDDEN: 'hidden.bs.collapse',
    CLICK_OR_TAP: 'click.collapseOut touchend.collapseOut'
  }

  /* --------------------------------------------------------------------------
    Private
  -------------------------------------------------------------------------- */

  function hideCollapse (el) {
    let $el = $(el)
    // Check that it's actually an open collapse
    if ($el.is('.collapse.show')) {
      $el.collapse('hide')
    }
  }

  // Add click handler to hide a navbar-collapse if user clicks outside of it.
  function initHideOnClickOutside () {
    for (let collapse of $(SELECTOR)) {
      // Only add click handler once collapse is open – more performant.
      $(collapse).on(Event.SHOWN, () => {
        $(document).on(Event.CLICK_OR_TAP, (e) => {
          let $clickover = $(e.target)

          // Hide only if click isnt on collapse or one of its children –
          // closest() checks that .collapse isn't a DOM ancestor of the target.
          if ($clickover.closest(collapse).length === 0) {
            hideCollapse(collapse)
          }
        })
      })

      // Remove document click handler when collapse closed
      $(collapse).on(Event.HIDDEN, () => {
        $(document).off(Event.CLICK_OR_TAP)
      })
    }
  }

  // Adds click handler that hides an open navbar-collapse if user clicks
  // a non-active link within it. (i.e. user finishes using the nav menu)
  //
  // This is only really necessary in an SPA, since real page transitions will
  // reload the navbar entirely.
  function initHideOnNavLinkClick () {
    for (let collapse of $(SELECTOR)) {
      const $navLink = $(collapse).find('a[href]')

      $navLink.click((e) => {
        if (!$(e.target).hasClass('active')) {
          hideCollapse(collapse)
        }
      })
    }
  }

  /* --------------------------------------------------------------------------
    Public
  -------------------------------------------------------------------------- */

  let Collapse = {
    init () {
      initHideOnClickOutside()
      initHideOnNavLinkClick()
    }
  }

  return Collapse
})(jQuery)

export default Collapse
